import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { parse } from 'date-fns';
import { bem, classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import When from 'components/When';

import './AvailabilitySummary.scss';

const messages = defineMessages({
  dowShort: {
    id: 'manage-services.components.availability-summary.dow-short',
    defaultMessage: '{dateTime,date,dow-short}',
  },
  multipleTimes: {
    id: 'manage-services.components.availability-summary.multiple-times',
    defaultMessage: 'Multiple times',
  },
  noRecurringSchedule: {
    id: 'manage-services.components.availability-summary.no-recurring-schedule',
    defaultMessage: 'No recurring schedule',
  },
  timeRange: {
    id: 'manage-services.components.availability-summary.time-range',
    defaultMessage: '{startTime, date, time} - {endTime, date, time}',
  },
});

const { block, element } = bem('availability-summary');

const AvailabilitySummary = ({ name, isNoRecurring, isSameTime, startTime, endTime, repeatDays, isInline = false }) => {
  return (
    <div className={block()}>
      <When predicate={!!name}>
        <h6>{name}</h6>
      </When>

      {isNoRecurring ? (
        <Message message={messages.noRecurringSchedule} />
      ) : (
        <>
          <span className={withMods(element('days'), { isInline })}>
            {repeatDays.map(({ short }) => short).join(', ')}
          </span>
          {!isSameTime ? (
            <Message message={messages.multipleTimes} />
          ) : (
            <Message
              values={{
                startTime: parse(startTime, 'HH:mm', new Date()),
                endTime: parse(endTime, 'HH:mm', new Date()),
              }}
              message={messages.timeRange}
            />
          )}
        </>
      )}
    </div>
  );
};

AvailabilitySummary.propTypes = {
  name: PropTypes.string,
  isNoRecurring: PropTypes.bool,
  isSameTime: PropTypes.bool,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  repeatDays: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  isInline: PropTypes.bool,
};

export default AvailabilitySummary;
